module.exports = __webpack_public_path__ + "media/toolkits/block-2-image-abc38ad9.png";